// src/pages/SarpanchKaryalaya.js
import React from "react";

/**
 * Final Sarpanch Karyalaya Page
 * - प्रशासक  नाव: यशोदा वामनराव पाटील
 * - गाव: भालेवाडी
 * - पंचायत समिती: करंजा
 * - जिल्हा परिषद: वर्धा
 *
 * Notes:
 * - Header logo (uploaded image) path included as a local path below.
 * - Sarpanch photo expected at: /public/images/sarpanch.jpeg
 * - If you prefer to use public folder logos, replace headerLogo with:
 *    const headerLogo = `${process.env.PUBLIC_URL}/images/sj1.jpg`;
 *   and add gpLogo similarly.
 */

// (Uploaded image local path — developer-provided)
const headerLogo = "/images/sj1.jpg";
//const logo = `${process.env.PUBLIC_URL}/images/sj1.jpg`; 
// Use sarpanch photo from public/images (as you mentioned earlier)
const sarpanchPhoto = `${process.env.PUBLIC_URL}/images/sarpanch.jpeg`;
// Optionally GP logo if available in public/images
const gpLogo = `${process.env.PUBLIC_URL}/images/gp.jpeg`;

const SarpanchKaryalaya = () => {
  return (
    <div style={styles.container}>
      {/* ===== Header ===== */}
      <header style={styles.header}>
        <div style={styles.logoArea}>
          <img src={headerLogo} alt="Maharashtra Logo" style={styles.headerLogo} />
        </div>

        <div style={styles.title}>
          <h1 style={styles.mainTitle}>ग्रामपंचायत भालेवाडी</h1>
          <p style={styles.subTitle}>पंचायत समिती करंजा | जिल्हा परिषद वर्धा</p>
          <p style={styles.smallNote}>महाराष्ट्र शासन · ग्रामविकास विभाग</p>
        </div>

        <div style={styles.gpLogoArea}>
          <img src={gpLogo} alt="GP Logo" style={styles.gpLogo} />
        </div>
      </header>

      {/* ===== प्रशासक  प्रोफाईल (फोटोसह) ===== */}
      <section style={styles.profileSection}>
        <div style={styles.profileCard}>
          {/* फोटो */}
          <div style={styles.photoContainer}>
            <img
              src={sarpanchPhoto}
              alt="Sarpanch...."
              style={styles.sarpanchPhoto}
            />
          </div>

          <div style={styles.profileInfo}>
            <h2 style={styles.sarpanchName}>माझी प्रशासक  यशोदा वामनराव पाटील</h2>
            <p style={styles.motto}>
              <strong>‘प्रत्येक नागरिकाच्या आवाजाला महत्त्व’</strong>
            </p>

            <div style={styles.profileMeta}>
              <p><strong>पद:</strong> प्रशासक </p>
              <p><strong>गाव:</strong> भालेवाडी</p>
              <p><strong>पंचायत समिती:</strong> करंजा</p>
              <p><strong>जिल्हा परिषद:</strong> वर्धा</p>
              {/* मोबाइल अजून न जोडल्यास यापुढे add करू शकता */}
            </div>
          </div>
        </div>
      </section>

      {/* ===== संदेश ===== */}
      <section style={styles.messageSection}>
        <h3 style={styles.sectionTitle}>प्रशासक ांचा संदेश</h3>
        <p style={styles.message}>
          <strong>मी. प्रशासक  यशोदा वामनराव पाटील</strong>, भालेवाडी नेतृत्वाची जबाबदारी स्वीकारताना हे सुनिश्चित करते/सुनिश्चित केले आहे की
          ग्रामपंचायतीचे दरवाजे <strong>प्रत्येक नागरीकासाठी खुले</strong> राहतील. आमचा कारभार
          <em> जनता-केंद्रित </em> असून सर्वांच्या सहभागाने गावाचा सर्वांगीण विकास करणे हा आमचा उद्देश आहे.
        </p>
      </section>

      {/* ===== मुख्य कर्तव्ये ===== */}
      <section style={styles.dutiesSection}>
        <h3 style={styles.sectionTitle}>मुख्य कर्तव्ये</h3>
        <ul style={styles.dutiesList}>
          <li>📌 ग्रामसभेचे आयोजन व कार्यवृत्त तयार करणे</li>
          <li>📌 कर वसुली, पाणीपट्टी, स्वच्छता शुल्क वाटप व नियंत्रण</li>
          <li>📌 मनरेगा, स्वच्छ भारत, PMAY योजना इत्यादींची अंमलबजावणी</li>
          <li>📌 जन्म-मृत्यू, लग्न नोंदणी आणि प्रमाणपत्रे जारी करणे</li>
          <li>📌 ग्रामपंचायत अभिलेख (नमुना १ ते ३३) योग्य प्रकारे ठेवणे</li>
        </ul>
      </section>

      {/* ===== यशोगाथा ===== */}
      <section style={styles.successSection}>
        <h3 style={styles.sectionTitle}>आमची यशोगाथा</h3>
        <p style={styles.intro}>
          आमच्या संघटनेने आणि गावकऱ्यांच्या सहकार्याने खालील महत्वाचे उपक्रम राबवले:
        </p>

        <div style={styles.successGrid}>
          <div style={styles.successCard}>
            <span style={styles.icon}>💧</span>
            <h4>जबाबदार पाणी व्यवस्थापन</h4>
            <p>जलसंधारण प्रकल्प पूर्ण करणे ज्यामुळे भूजल पातळी सुधारली आहे.</p>
          </div>

          <div style={styles.successCard}>
            <span style={styles.icon}>🏗️</span>
            <h4>रस्ते व पायाभूत सोयी</h4>
            <p>ग्रामांतील मुख्य रस्ते सुधारले व सार्वजनिक सुविधांचे नूतनीकरण केले.</p>
          </div>

          <div style={styles.successCard}>
            <span style={styles.icon}>🌿</span>
            <h4>स्वच्छता व पर्यावरण</h4>
            <p>स्वच्छ भारत मोहिमेत ग्रामस्वच्छतेचे आयोजन आणि प्लास्टिक कमी करण्याचे प्रयत्न.</p>
          </div>
        </div>
      </section>

      {/* ===== तरुणांसाठी ===== */}
      <section style={styles.youthSection}>
        <h3 style={styles.sectionTitle}>तरुणांसाठी उपक्रम</h3>
        <div style={styles.youthGrid}>
          <div style={styles.youthCard}>
            <span style={styles.icon}>💻</span>
            <h4>डिजिटल कौशल्ये</h4>
            <p>कॉम्प्युटर व शॉर्ट-टर्म ट्रेनिंग केंद्र सुरु करणे.</p>
          </div>
          <div style={styles.youthCard}>
            <span style={styles.icon}>🏃‍♀️</span>
            <h4>खेळ व आरोग्य</h4>
            <p>सार्वजनिक व्यायामशाळा व खेळाचे मैदान विकसित करणे.</p>
          </div>
        </div>
      </section>

      {/* ===== समाप्ती संदेश ===== */}
      <section style={styles.closingSection}>
        <p style={styles.closing}>
          <strong>भालेवाडी नागरिकांचे प्रेम आणि विश्वास हीच आमच्या कामाची खरी प्रेरणा आहे.</strong>
          <br />
          आपण मिळून, आपला विकास निश्चित करूया.
        </p>
      </section>

      {/* ===== फूटर ===== */}
      <footer style={styles.footer}>
        <p>© 2025 भालेवाडी | सर्व हक्क राखीव</p>
        <p>
          वेबसाइट:{" "}
          <a href="https://gpbhalewadi.in" style={styles.link}>
            gpbhalewadi.in
          </a>
        </p>
      </footer>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    maxWidth: "980px",
    margin: "20px auto",
    padding: "22px",
    background: "#ffffff",
    border: "1px solid #e0e7ff",
    borderRadius: "14px",
    boxShadow: "0 10px 30px rgba(2,6,23,0.08)",
    color: "#222",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    borderBottom: "3px solid #1e88e5",
    paddingBottom: "14px",
    marginBottom: "22px",
  },
  logoArea: {
    flex: "0 0 90px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  headerLogo: {
    maxWidth: "86px",
    maxHeight: "86px",
    objectFit: "contain",
    borderRadius: "8px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
  },
  gpLogoArea: {
    flex: "0 0 70px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  gpLogo: {
    width: "70px",
    height: "70px",
    objectFit: "cover",
    borderRadius: "8px",
  },
  title: { flex: 1, textAlign: "center" },
  mainTitle: { margin: 0, fontSize: "26px", color: "#0d47a1", fontWeight: "700" },
  subTitle: { margin: "6px 0 0", fontSize: "15px", color: "#444" },
  smallNote: { margin: "4px 0 0", fontSize: "13px", color: "#0077c2", fontWeight: 600 },

  profileSection: { marginBottom: "26px" },
  profileCard: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    background: "linear-gradient(135deg,#f0f7ff,#e8f3ff)",
    padding: "18px",
    borderRadius: "12px",
    border: "1px solid #dbeafe",
  },
  photoContainer: {
    flex: "0 0 140px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  sarpanchPhoto: {
    width: "140px",
    height: "140px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "6px solid #fff",
    boxShadow: "0 8px 24px rgba(2,6,23,0.12)",
  },
  profileInfo: { flex: 1 },
  sarpanchName: { margin: "0 0 6px 0", fontSize: "22px", color: "#0b63a3" },
  motto: { margin: "0 0 12px 0", fontSize: "16px", color: "#0b84c9", fontStyle: "italic" },
  profileMeta: { display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: "6px" },

  messageSection: {
    marginBottom: "22px",
    background: "#fff",
    padding: "16px",
    borderRadius: "10px",
    borderLeft: "5px solid #42a5f5",
  },
  sectionTitle: {
    color: "#1976d2",
    borderBottom: "2px solid #1976d2",
    paddingBottom: "8px",
    marginTop: 0,
    marginBottom: "14px",
    fontSize: "20px",
  },
  message: { fontSize: "16px", lineHeight: "1.7", margin: 0 },

  dutiesSection: { marginBottom: "22px" },
  dutiesList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "grid",
    gap: "10px",
    gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
  },
  dutiesListItem: {},

  successSection: { marginBottom: "22px" },
  intro: { marginBottom: "12px", fontSize: "16px" },
  successGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
    gap: "14px",
  },
  successCard: {
    background: "#e8f5e9",
    padding: "14px",
    borderRadius: "10px",
    border: "1px solid #c8e6c9",
    textAlign: "center",
  },
  icon: { fontSize: "28px", display: "block", marginBottom: "8px" },

  youthSection: { marginBottom: "22px" },
  youthGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
    gap: "12px",
  },
  youthCard: {
    background: "#fff3e0",
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid #ffd79b",
    textAlign: "center",
  },

  closingSection: {
    background: "linear-gradient(135deg,#fff8e1,#ffecb3)",
    padding: "20px",
    borderRadius: "12px",
    textAlign: "center",
    border: "1px dashed #ffb300",
    marginBottom: "18px",
  },
  closing: { fontSize: "18px", lineHeight: "1.8", margin: 0, color: "#e65100" },

  footer: {
    textAlign: "center",
    paddingTop: "12px",
    borderTop: "1px solid #eee",
    fontSize: "14px",
    color: "#666",
  },
  link: { color: "#1976d2", textDecoration: "none" },
};

export default SarpanchKaryalaya;
